/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

/**
 * Utility function to check points availability for specific actions
 * @param action The action to check points for (e.g., "create_character")
 * @returns Object containing success status and error message if applicable
 */
export const checkPointsAvailability = async (action: string) => {
  try {
    const response = await fetch("/api/points/check-availability", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: action,
      }),
      credentials: "include",
    });

    const data = await response.json();

    if (data.success) {
      return { success: true };
    } else if (data.error) {
      return {
        success: false,
        errorMessage: `You need at least ${data.points_required} points to create a character. Check your account page for more details.`,
      };
    }
  } catch (error) {
    console.error(`Error checking points for ${action}:`, error);
    return {
      success: false,
      errorMessage: "Failed to check points availability",
    };
  }
};
